import { createContext, useContext } from "react";

export interface ModalContextState {
  onClose?: () => void;
  scrollable?: boolean;
  portalRoot?: HTMLElement | null;
}

export const ModalContext = createContext<ModalContextState>({});

export function useModal() {
  return useContext(ModalContext);
}
